module.exports = require('./lib/_stream_duplex.js');



// WEBPACK FOOTER //
// (webpack)/~/readable-stream/duplex-browser.js